import { ParsedResponse, getParsedResponse } from "./responses";
import { getAuthHeaders, getCsrfHeaders } from "./headers";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import reachApi from "./reachServiceClient";

export async function get<T>(
  path: string,
  config: AxiosRequestConfig = {},
  responseHandler: (resp: AxiosResponse) => Promise<ParsedResponse<T>> = getParsedResponse
): Promise<ParsedResponse<T>> {
  const resp = await reachApi.get(path, {
    ...{
      headers: {
        Accept: "application/json",
        ...getAuthHeaders()
      }
    },
    ...config
  });

  return await responseHandler(resp);
}

export async function post<T>(
  path: string,
  payload: any,
  config: AxiosRequestConfig = {},
  responseHandler: (resp: AxiosResponse) => Promise<ParsedResponse<T>> = getParsedResponse
): Promise<ParsedResponse<T>> {
  const resp = await reachApi.post(path, payload, {
    ...{
      headers: {
        Accept: "application/json",
        ...getAuthHeaders(),
        ...getCsrfHeaders()
      }
    },
    ...config
  });

  return await responseHandler(resp);
}

export async function postForm<T>(
  path: string,
  payload: any,
  config: AxiosRequestConfig = {},
  responseHandler: (resp: AxiosResponse) => Promise<ParsedResponse<T>> = getParsedResponse
): Promise<ParsedResponse<T>> {
  const resp = await reachApi.post(path, payload, {
    ...{
      headers: {
        ...getAuthHeaders(),
        ...getCsrfHeaders(),
        "Content-Type": "multipart/form-data"
      }
    },
    ...config
  });

  return await responseHandler(resp);
}

export async function put<T>(
  path: string,
  payload: any,
  config: AxiosRequestConfig = {},
  responseHandler: (resp: AxiosResponse) => Promise<ParsedResponse<T>> = getParsedResponse
): Promise<ParsedResponse<T>> {
  const resp = await reachApi.put(path, payload, {
    ...{
      headers: {
        Accept: "application/json",
        ...getAuthHeaders(),
        ...getCsrfHeaders()
      }
    },
    ...config
  });

  return await responseHandler(resp);
}

export async function patch<T>(
  path: string,
  payload: any,
  config: AxiosRequestConfig = {},
  responseHandler: (resp: AxiosResponse) => Promise<ParsedResponse<T>> = getParsedResponse
): Promise<ParsedResponse<T>> {
  const resp = await reachApi.patch(path, payload, {
    ...{
      headers: {
        Accept: "application/json",
        ...getAuthHeaders(),
        ...getCsrfHeaders()
      }
    },
    ...config
  });

  return await responseHandler(resp);
}

export async function del<T>(
  path: string,
  config: AxiosRequestConfig = {},
  responseHandler: (resp: AxiosResponse) => Promise<ParsedResponse<T>> = getParsedResponse
): Promise<ParsedResponse<T>> {
  const resp = await reachApi.delete(path, {
    ...{
      headers: {
        Accept: "application/json",
        ...getAuthHeaders(),
        ...getCsrfHeaders()
      }
    },
    ...config
  });

  return await responseHandler(resp);
}
//
// export async function request<T>(
//   path: string,
//   params: RequestInit = {},
//   responseHandler: (resp: AxiosResponse) => Promise<ParsedResponse<T>> = getParsedResponse
// ): Promise<ParsedResponse<T>> {
//   const resp = await fetch(path, {
//     ...{
//       headers: {
//         Accept: "application/json",
//         ...getAuthHeaders()
//       },
//       credentials: "same-origin"
//     },
//     ...params
//   });
//
//   return await responseHandler(resp);
// }
//
// // eslint-disable-next-line max-len
// export function post<T>(
//   path: string,
//   pars: any,
//   opts: RequestInit = {}
// ): Promise<ParsedResponse<T>> {
//   return request(path, {
//     ...{
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json;charset=utf-8",
//         ...getCsrfHeaders()
//       },
//       body: JSON.stringify(pars)
//     },
//     ...opts
//   });
// }
//
// export function postForm<T>(
//   path: string,
//   body: FormData,
//   opts: RequestInit = {}
// ): Promise<Response> {
//   return fetch(path, {
//     ...{
//       method: "POST",
//       body
//     },
//     ...opts
//   });
// }
//
// export function put<T>(
//   path: string,
//   pars: any,
//   opts: RequestInit = {}
// ): Promise<ParsedResponse<T>> {
//   return post(path, pars, { ...opts, method: "PUT" });
// }
//
// export function patch<T>(
//   path: string,
//   pars: any,
//   opts: RequestInit = {}
// ): Promise<ParsedResponse<T>> {
//   return post(path, pars, { ...opts, method: "PATCH" });
// }
//
// // "Delete" is reserved
// export function del<T>(
//   path: string,
//   pars: any = {},
//   opts: RequestInit = {}
// ): Promise<ParsedResponse<T>> {
//   return post(path, pars, { ...opts, method: "DELETE" });
// }
